import { render } from "./Checkboxes.vue?vue&type=template&id=52bc246a&scoped=true"
import script from "./Checkboxes.vue?vue&type=script&lang=js"
export * from "./Checkboxes.vue?vue&type=script&lang=js"

import "./Checkboxes.vue?vue&type=style&index=0&id=52bc246a&scoped=true&lang=scss"

import exportComponent from "/Users/johnguanlao/Desktop/wrk/CodeTogether/RSJI-Equity-Actions/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bc246a"]])

export default __exports__